module.exports = __webpack_public_path__ + "img/em-banner.4e3a4e0e.png";